// local
import { sharedRaceFile } from './shared-races.js';

// packages
import { createSingleRaceFeed } from './stores.js';

import {
  renderSvelteComponent,
  findElementInShadowDom,
  findElementByIdInShadowDom,
} from './utils/render.js';

// components
import AtAGlanceContainer from './components/AtAGlanceContainer.svelte';

const crosswalk = window.CROSSWALK.assets.img;

//components

async function main() {
  // [id, source] for each race: follows scripts/shared-races.js
  const mayor = sharedRaceFile('CA-84303');
  const cd3 = sharedRaceFile('CA-84459');
  const cd9 = sharedRaceFile('CA-84460');
  const fd = sharedRaceFile('CA-85069');

  const [mayorfeed, cd3feed, cd9feed, fdfeed] = await Promise.all([
    createSingleRaceFeed(...mayor),
    createSingleRaceFeed(...cd3),
    createSingleRaceFeed(...cd9),
    createSingleRaceFeed(...fd),
  ]);

  const atAGlanceRaces = [
    {
      id: mayor[0],
      label: 'L.A. Mayor',
      feed: mayorfeed,
    },
    {
      id: cd3[0],
      label: 'L.A. City Council District 3',
      feed: cd3feed,
    },
    {
      id: cd9[0],
      label: 'L.A. City Council District 9',
      feed: cd9feed,
    },
    {
      id: fd[0],
      label: 'L.A. Measure F.D.',
      feed: fdfeed,
    },
  ];

  // Each feed is a per-race file (RACE_URL), so the feed already is the race
  atAGlanceRaces.forEach((/** @type {any} */ r) => {
    r['store'] = r['feed'];
  });

  let aagContainer = findElementByIdInShadowDom('aag-la-city');
  if (!aagContainer) return;

  renderSvelteComponent(
    AtAGlanceContainer,
    /** @type {HTMLElement} */ (aagContainer),
    {
      feed: atAGlanceRaces,
      crosswalk,
      // 'primary' shows the primary-only lines (top two advance, leading
      // candidates); 'general' hides them
      cycle: 'general',
      // true to show "*"" next to incumbents, and "* Incumbent" in the legend
      showIncumbents: true,
    }
  );
}

main().catch(console.error);
